export const UPDATE_LEGAL_COUNTRY_LANGUAGE = 'UPDATE_LEGAL_COUNTRY_LANGUAGE';
